var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmittedIllustration, SubmittedSubText, SubmittedText, SubmittedTextDuration, SubmittedWrapper } from '../subcomponents';
import CBRContext from '../../context';
import InProgressIllustration from '../../error/in-progress-illustration';
import SubmissionIllustration from '../../error/submission-illustration';
import { analyticsValues, triggerAnalyticsKeys } from '../../../../const/analytics';
var Submitted = function (_a) {
    var _b;
    var _c = _a.isCbrExecution, isCbrExecution = _c === void 0 ? false : _c, desc = _a.desc, subtext = _a.subtext;
    var t = useTranslation().t;
    var triggerAnalyticsEvent = useContext(CBRContext).triggerAnalyticsEvent;
    var submittedSubTextArray = subtext.split('{{duration}}');
    var firstPart = submittedSubTextArray[0], lastPart = submittedSubTextArray[1];
    triggerAnalyticsEvent((_b = {},
        _b[triggerAnalyticsKeys.pageName] = analyticsValues.submitted,
        _b[triggerAnalyticsKeys.message] = isCbrExecution
            ? analyticsValues.refundSubmitted
            : analyticsValues.refundInProgress,
        _b[triggerAnalyticsKeys.pageKind] = analyticsValues.cbr,
        _b[triggerAnalyticsKeys.pageFunction] = analyticsValues.manageCreditBalance,
        _b));
    return (_jsxs(SubmittedWrapper, { children: [_jsx(SubmittedIllustration, { children: isCbrExecution ? (_jsx(SubmissionIllustration, {})) : (_jsx(InProgressIllustration, {})) }), _jsx(SubmittedText, { children: desc }), _jsxs(SubmittedSubText, __assign({ isCbrExecution: isCbrExecution }, { children: [firstPart, _jsxs(SubmittedTextDuration, { children: [" ", t('text.duration')] }), lastPart] }))] }));
};
export default Submitted;
